<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <div slot='header'>
            <strong><i class="fa fa-align-justify"></i> Créer une nouvelle campagne</strong>
          </div>
          <b-card-body class="small-padding">
            <b-form v-on:submit.prevent="save">
              <b-card no-body>
                <b-row>
                  <b-col sm="12">
                    <div class="card-smallHeader card-header-action mb-2">
                      <span style="color: #d9418b" class="mr-2"><b>Critères Campagne</b></span>
                    </div>
                  </b-col>
                </b-row>
                <b-row style="margin-right:5px;margin-left:5px">
                  <b-col sm="4">
                    <b-form-group label="Libellé campagne" label-for="libelle_campagne">
                      <b-form-input id="libelle_campagne" type="text" :class="{hasError: errors.libelle !== ''}"
                                    v-model="libelle"></b-form-input>
                      <span class="field-error">{{ errors.libelle }}</span>
                    </b-form-group>
                    <b-form-group label="Motif de l'opération" label-for="motif_op">
                      <b-form-select id="motif_op" v-model="motif_op" :options="motifsControle"
                                    :class="{hasError: errors.motif_op !== ''}">
                      </b-form-select>
                      <span class="field-error">{{ errors.motif_op }}</span>
                    </b-form-group>
                    <b-form-group label="Type de contrôle" label-for="type_controle">
                      <b-form-select id="type_controle" v-model="type_controle" :options="typesControle"
                                    :class="{hasError: errors.type_controle !== ''}">
                      </b-form-select>
                      <span class="field-error">{{ errors.type_controle }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group label="Valideur" label-for="valideur">
                      <auto-select
                        id="valideur"
                        v-model="gestionnaire"
                        :items="gestionnaires"
                        :loading="loadingGestionnaire"
                        item-value="id"
                        item-text="nom"
                        :placeholder="gestionnaire ? '' : 'Entrer le nom du valideur'"
                        disable-filtering-by-search
                        @search="onSearchGestionnaire"
                        v-on:keyup.enter="onEnter()"
                      >
                        <template #no-data>
                          {{ noData ? "Aucun valideur trouvé." : "Il faut au moins 2 caractères pour la recherche."
                          }}
                        </template>
                        <template slot="item" slot-scope="{ item: gest }">
                          <div style="display: flex; align-items: center;" @click="onClick($event, gest)">
                            <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                          </div>
                        </template>
                        <template slot="selection" slot-scope="{ item: gest }">
                          <div style="display: flex; align-items: center;">
                            <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                          </div>
                        </template>
                        <template v-if="loadingGestionnaire" #input-end>
                          <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
                        </template>
                      </auto-select>
                    </b-form-group>
                    <b-form-group label="Demandeur" label-for="demandeur">
                      <b-form-input id="demandeur" type="text" v-model="demandeur"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Descriptif" label-for="descriptif">
                      <b-form-textarea id="descriptif" type="text" rows="3" max-rows="6" v-model="descriptif">
                      </b-form-textarea>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group label="Echantillon annuel" label-for="echantillon_annuel">
                      <b-form-input id="echantillon_annuel" type="number" v-model="echantillonAnnuel"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Fréquence" label-for="frequence">
                      <b-form-input id="frequence" type="text" v-model="frequence"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
              <b-card no-body>
                <b-row>
                  <b-col sm="12">
                    <div class="card-smallHeader card-header-action mb-2">
                      <span style="color: #d9418b" class="mr-2"><b>Critères Dossier</b></span>
                    </div>
                  </b-col>
                </b-row>
                <b-row style="margin-right:5px;margin-left:5px">
                  <b-col sm="4">
                    <b-form-group label="Date de réception du" label-for="date_du">
                      <b-form-input id="date_du" type="date" v-model="date_du"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Date de réception Au" label-for="date_au">
                      <b-form-input id="date_au" type="date" v-model="date_au"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Traitement" label-for="traitement">
                      <b-form-select id="traitement" v-model="traitementId" :options="traitementsOptions">
                        <template v-slot:first>
                          <b-form-select-option :value="''" disabled :class="{hasError: errors.traitementId !== ''}">-- Choisir un traitement --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <span class="field-error">{{ errors.traitementId }}</span>
                    </b-form-group>
                    <div v-if="displayDateSinistre">
                      <b-form-group label="Date du sinistre du" label-for="date_sinistre_du">
                        <b-form-input id="date_sinistre_du" type="date" v-model="date_sinistre_du"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Date du sinistre Au" label-for="date_sinistre_au">
                        <b-form-input id="date_sinistre_au" type="date" v-model="date_sinistre_au"></b-form-input>
                      </b-form-group>
                    </div>
                    <!-- <b-form-group label="NIR" label-for="nir" sm="6">
                      <b-form-input type="text" id="nir" v-model="nir" placeholder="Commence par..."></b-form-input>
                    </b-form-group> -->
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="nir" style="margin-top: 10px">NIR :</label>
                      </b-col>
                      <b-col sm="4">
                          <b-form-input type="text" id="nir" v-model="nir" placeholder="Commence par..."></b-form-input>
                      </b-col>
                      <b-col sm="2">
                        <label for="idpp" style="margin-top: 10px">IDPP :</label>
                      </b-col>
                      <b-col sm="4">
                          <b-form-input type="text" id="idpp" v-model="idpp" placeholder="N° NSI"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-form-group label="Type" label-for="type">
                      <multiselect id="type" selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                                  v-model="type" tag-placeholder="Choisissez un type"
                                  placeholder="Choisissez un type" label="name" track-by="code" :options="allTypes"
                                  :multiple="true" :taggable="true">
                      </multiselect>
                    </b-form-group>
                    <b-form-group label="Statut du dossier" label-for="statut_dossier">
                      <multiselect id="statut_dossier" selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                                  v-model="status" tag-placeholder="Choisissez un status"
                                  placeholder="Par défaut Tous" label="name" track-by="code"
                                  :options="allStatusOption" :multiple="true" :taggable="true">
                      </multiselect>
                    </b-form-group>
                    <b-form-group label="Sous Statut" label-for="sous_statut_dossier">
                      <multiselect id="sous_statut_dossier" selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                                  v-model="sousStatus" tag-placeholder="Choisissez un status"
                                  placeholder="Par défaut Tous" label="name" track-by="code"
                                  :options="allSousStatusOption" :multiple="true" :taggable="true"
                                  :disabled="status.length !== 1">
                      </multiselect>
                    </b-form-group>
                    <b-form-group label="Statut Prest'IJ" label-for="statut_prestij">
                      <multiselect id="statut_prestij" selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner'
                                  :close-on-select="false"
                                  v-model="statusPrestij"
                                  tag-placeholder="Choisissez un status prest ij"
                                  placeholder="Par défaut Tous"
                                  label="name"
                                  track-by="code"
                                  :options="allStatusPrestij"
                                  :multiple="true"
                                  :taggable="true">
                      </multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group label="Siren" label-for="siren">
                      <b-form-input type="text" placeholder="Saisir un SIREN" id="siren" v-model="siren" v-on:keyup="validateSiren" :class="{hasError: errors.siren !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.siren }}</span>
                    </b-form-group>
                    <b-row class="mb-1">
                      <b-col sm="3" style="margin-top: 10px">
                        <label>Groupe Siren :</label>
                      </b-col>
                      <b-col sm="6">
                        <multiselect id="group_siren" selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner'
                                  :close-on-select="false"
                                  v-model="groupSirens"
                                  tag-placeholder="Choisissez un groupe de siren"
                                  placeholder="Par défaut Tous"
                                  label="name"
                                  track-by="code"
                                  :options="allGroupSirens"
                                  :multiple="true"
                                  :taggable="true">
                        </multiselect>
                      </b-col>
                      <b-col sm="3" style="margin-top:10px;">
                        <span style="display:table-cell;vertical-align:middle;">
                          <strong style="margin-right: 10px">exclus</strong>
                        </span>
                        <span style="display:table-cell;vertical-align:middle;">
                          <b-form-checkbox v-model="exclureGroupeSiren" style="margin-right: 10px"></b-form-checkbox>
                        </span>
                      </b-col>
                    </b-row>
                    <b-form-group label="Canal" label-for="canal">
                      <multiselect id="canal" selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                                  v-model="canal" tag-placeholder="Choisissez un canal"
                                  placeholder="Choisissez un canal" label="name" track-by="code"
                                  :options="allCanals" :multiple="true" :taggable="true">
                      </multiselect>
                    </b-form-group>
                    <b-form-group label="Segment" label-for="segment">
                      <multiselect id="segment" selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                                  v-model="segment" tag-placeholder="Choisissez un segment"
                                  placeholder="Choisissez un segment" label="name" track-by="code"
                                  :options="allSegments" :multiple="true" :taggable="true">
                      </multiselect>
                    </b-form-group>
                    <b-form-group label="Flag" label-for="flag">
                      <multiselect id="flag" selectLabel='Appuyer sur entrer pour sélectionner' 
                          selectedLabel='Sélectionné' 
                          deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false" 
                          v-model="flag" tag-placeholder="Choisissez un flag" 
                          placeholder="Choisissez un flag" label="name" track-by="code" 
                          :options="flagOptions" :multiple="true" :taggable="true">
                        </multiselect>
                    </b-form-group>
                    <b-form-group label="Règle de cumul" label-for="regleCumul">
                      <b-form-select v-model="regleCumul" :options="allRegleCumulOption">
                        <template v-slot:first>
                          <b-form-select-option :value="''">-- Choisir une règle --</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group label="Type Urgence" label-for="typeUrgence">
                      <multiselect id="typeUrgence" selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                                  v-model="typeUrgence" tag-placeholder="Choisissez un type urgence"
                                  placeholder="Choisissez un type urgence" label="name" track-by="code"
                                  :options="allTypesUrgences" :multiple="true" :taggable="true">
                      </multiselect>
                    </b-form-group>
                    <!-- <b-form-group label="Urgences Directions" label-for="is_urgent">
                      <b-form-checkbox v-model="is_urgent"></b-form-checkbox>
                    </b-form-group> -->
                  </b-col>
                  <b-col sm="4">
                    <b-form-group label="Famille produit" label-for="famille_produit">
                      <multiselect id="famille_produit" selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                                  v-model="produit" tag-placeholder="Choisissez un produit"
                                  placeholder="Choisissez un produit" label="name" track-by="code"
                                  :options="allProduits" :multiple="true" :taggable="true">
                      </multiselect>
                    </b-form-group>
                    <b-form-group label="Equipe affectée" label-for="equipes">
                      <b-form-select id="equipes" v-model="equipes" :options="allEquipesOption">
                        <template v-slot:first>
                          <b-form-select-option :value="''">-- Choisir une équipe --</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group label="Gestionnaire affecté" label-for="gestionnaire_affecte">
                      <auto-select
                        id="gestionnaire_affecte"
                        v-model="gestionnaire_affecte"
                        :items="gestionnairesAffectes"
                        :loading="loadingGestionnaireAffecte"
                        item-value="id"
                        item-text="nom"
                        :placeholder="gestionnaire_affecte ? '' : 'Entrer le nom du gestionnaire affecté'"
                        disable-filtering-by-search
                        @search="onSearchGestionnaireAffecte"
                        v-on:keyup.enter="onEnter()">
                        <template #no-data>
                          {{ noData ? "Aucun gestionnaire affecté trouvé." : "Il faut au moins 2 caractères pour la recherche."
                          }}
                        </template>
                        <template slot="item" slot-scope="{ item: gest }">
                          <div style="display: flex; align-items: center;" @click="onClick($event, gest)">
                            <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                          </div>
                        </template>
                        <template slot="selection" slot-scope="{ item: gest }">
                          <div style="display: flex; align-items: center;">
                            <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                          </div>
                        </template>
                        <template v-if="loadingGestionnaireAffecte" #input-end>
                          <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
                        </template>
                      </auto-select>
                    </b-form-group>
                    <b-form-group label="Segment Commercial" label-for="segment_commercial">
                      <multiselect id="segment_commercial" selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner'
                                  :close-on-select="false"
                                  v-model="segmentsCommerciaux"
                                  tag-placeholder="Choisissez un segment commercial"
                                  placeholder="Par défaut Tous"
                                  label="name"
                                  track-by="code"
                                  :options="allSegmentsCommerciaux"
                                  :multiple="true"
                                  :taggable="true">
                      </multiselect>
                    </b-form-group>
                    <b-form-group label="Délégation Commerciale" label-for="delegation_commerciale">
                      <multiselect id="delegation_commerciale" selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner'
                                  :close-on-select="false"
                                  v-model="delegations"
                                  tag-placeholder="Choisissez une délégation"
                                  placeholder="Par défaut Tous"
                                  label="name"
                                  track-by="code"
                                  :options="allDelegations"
                                  :multiple="true"
                                  :taggable="true">
                      </multiselect>
                    </b-form-group>
                    <b-form-group label="OAG" label-for="oag">
                      <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                  selectedLabel='Sélectionné'
                                  deselectLabel='Appuyer sur entrer pour désélectionner'
                                  :close-on-select="false"
                                  v-model="oags"
                                  tag-placeholder="Choisissez un OAG"
                                  placeholder="Par défaut Tous"
                                  label="name"
                                  track-by="code"
                                  id="oag"
                                  :options="oagOptions" :multiple="true"
                                  :taggable="true">
                      </multiselect>
                    </b-form-group>
                    <b-form-group label="OAP" label-for="oap">
                      <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                     selectedLabel='Sélectionné'
                                     deselectLabel='Appuyer sur entrer pour désélectionner'
                                     :close-on-select="false"
                                     v-model="oaps"
                                     tag-placeholder="Choisissez un OAP"
                                     placeholder="Par défaut Tous"
                                     label="name"
                                     track-by="code"
                                     id="oap"
                                     :options="oapOptions" :multiple="true"
                                     :taggable="true">
                      </multiselect>
                    </b-form-group>
                    <b-row class="mb-1" style="margin-bottom: 12px !important">
                      <b-col sm="3">
                        <label for="nbDossierNir">Dossiers ouverts par NIR </label>
                      </b-col>
                      <b-col sm="9">
                        <div style="display:table;">
                        <b-form-input style="width:150px; display:table-cell;vertical-align:middle;margin-right: 10px;" v-model="nbDossierNir" id="nbDossierNir" type="range" min="0" max="50" step="5">
                        </b-form-input>
                        <span style="display:table-cell;vertical-align:middle;">
                          <b-badge style="margin-right: 20px" pill variant="success">{{ displayNbDossierNir() }}</b-badge>
                        </span>
                        <span style="display:table-cell;vertical-align:middle;">
                          <strong style="margin-right: 10px">hors BPIJ</strong>
                        </span>
                        <span style="display:table-cell;vertical-align:middle;">
                          <b-form-checkbox v-model="exclureBpij" style="margin-right: 10px"></b-form-checkbox>
                        </span>
                      </div>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                       <b-form-group style="margin-left: 15px">
                        <label for="date_traitement">Date changement statut </label>
                        <b-row>
                          <b-col sm="4">
                            <b-form-input id="date_traitement" type="date" v-model="dateTraitement"></b-form-input>
                          </b-col>
                          <b-col sm="8">
                            <b-form-select id="traitement_status" v-model="traitementStatusId" :options="traitementsOptions">
                            <template v-slot:first>
                              <b-form-select-option :value="''" disabled :class="{hasError: errors.traitementStatusId !== ''}">-- Choisir un traitement --
                              </b-form-select-option>
                            </template>
                            </b-form-select>
                            <span class="field-error">{{ errors.traitementStatusId }}</span>
                          </b-col>
                        </b-row>
                       </b-form-group>
                    </b-row>
                  </b-col>
                </b-row>
              </b-card>
              <div class="footer borded-top mt-1">
                <b-button class="float-right mb-1" @click.prevent="save" size="md"
                          variant="primary">
                  <i class="fa fa-search"></i> Enregistrer
                </b-button>
                <b-button type="button" @click.prevent="clearForm" size="md" variant="secondary"
                          class="mr-1 mb-1 float-right">
                  <i class="fa fa-eraser"></i> Effacer
                </b-button>
              </div>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  import Multiselect from 'vue-multiselect';
  import {CoolSelect as AutoSelect} from 'vue-cool-select';
  import dossier_form_mixin from "../../../mixins/dossier-form-mixin";
  import {isEmpty, checkSIREN} from "@/utils/fileHelper";
  import {canSeeCritere} from "@/utils/communHelper";

  export default {
    name: "Add",
    mixins: [dossier_form_mixin],
    components: {
      Multiselect,
      AutoSelect,
    },
    data() {
      return {
        canSeeCritere,
        libelle: '',
        type_controle: '',
        motif_op: '',
        echantillonAnnuel: '',
        frequence: '',
        demandeur: '',
        gestionnaire_affecte: '',
        descriptif: '',
        traitementId: '',
        isEmpty,
        errors: {
          libelle: "",
          type_controle: "",
          motif_op: "",
          siren: "",
          traitementId: "",
          flag: "",
        },
        allTraitements : [],
        typesControle: [],
        motifsControle: [],
        flag: '',
        flagOptions: [],
        is_urgent: '',
        allRegleCumulOption: [],
        regleCumul: '',
        nbDossierNir: 0,
        exclureBpij: '',
        equipes: '',
        allEquipesOption: [],
		    exclureGroupeSiren: '',
        dateTraitement: '',
        traitementStatusId: '',
        displayDateSinistre: false,
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    mounted() {
      this.getTraitementsPrincipaux()
      this.getStatusTraiteId();
      this.getTypesControle()
      this.getMotifsControle()
      this.getReglesCumul()
      this.getEquipes()
    },
    watch: {
      traitementId: function(){
        this.displayDateSinistre = false;
        if(this.traitementId){
          let traitementDeces = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_dc');
          let traitementInval = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_inval');
          let traitementIj = this.allTraitements.find(traitement => traitement.libelle_technique === 'ij_gestion_prestation');
          let traitementIjModulePrev = this.allTraitements.find(traitement => traitement.libelle_technique === 'ij_module_prevoyance');

          if(this.traitementId === traitementDeces.id 
            || this.traitementId === traitementInval.id 
            || this.traitementId === traitementIj.id 
            || this.traitementId === traitementIjModulePrev.id){
            this.displayDateSinistre = true;
          }else{
            this.date_sinistre_du = '';
            this.date_sinistre_au = '';
          }
        }
      },
    },
    methods: {
      save() {
        let self = this;
        this.clearErrors();
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let dataPost = this.buildSaveQueryData();
          // console.log(dataPost)
          this.$axios
            .post("/espaceQualite/campagnes/store", dataPost)
            .then((result) => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Création avec succès",
                text: "La campagne a été bien crée",
                showConfirmButton: false,
                timer: 4000
              });
              setTimeout(this.$router.push({path: '/espace-qualite/campagnes/detail/' + result.data.campagne_id}), 5000);
            })
            .catch((error) => {
              let errorText = "";
              self.$store.commit("IS_LOADING", false);
              if (error.response && error.response.status === 406) {
                errorText = error.response.data.message;
              } else {
                errorText = "Une erreur est survenue, lors de la suppression du type. Si le problème persiste, merci de faire un ticket au support DOSI.";
              }
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: errorText,
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter un administrateur',
          showConfirmButton: false,
          timer: 4000,
        });
      },
      validateData() {
        let valid = true;
        if (isEmpty(this.libelle.trim())) {
          this.errors.libelle = "Le libellé est obligatoire";
          valid = false;
        }
        if (isEmpty(this.type_controle)) {
          this.errors.type_controle = "Le type de contrôle est obligatoire";
          valid = false;
        }
        if (isEmpty(this.motif_op)) {
          this.errors.motif_op = "Le motif de l'opération est obligatoire";
          valid = false;
        }
        if (!isEmpty(this.status) && isEmpty(this.traitementId)) {
          this.errors.traitementId = "Veuillez séléctionner un traitement";
          valid = false;
        }
        if (!isEmpty(this.dateTraitement) && isEmpty(this.traitementStatusId)) {
          this.errors.traitementStatusId = "Veuillez séléctionner un traitement";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.libelle = "";
        this.errors.type_controle = "";
        this.errors.motif_op = "";
        this.errors.traitementId = "";
        this.errors.traitementStatusId = "";
      },
      buildSaveQueryData() {
        return {
          'libelle': this.libelle,
          'type_controle': this.type_controle,
          'motif_controle': this.motif_op,
          'date_debut': this.date_du,
          'date_fin': this.date_au,
          'valideur': this.gestionnaire,
          'gestionnaire_affecte': this.gestionnaire_affecte,
          'siren': this.siren,
          'nir': this.nir,
          'id_pp': this.idpp,
          'produit': this.selectedProduits,
          'segment': this.selectedSegments,
          'canal': this.selectedCanals,
          'type': this.selectedTypes,
          'categorie': this.selectedCategory,
          'traitement': this.traitementId,
          'date_sinistre_du': this.date_sinistre_du,
          'date_sinistre_au': this.date_sinistre_au,
          'group_siren': this.selectedGroupSirens,
		      'exclureGroupeSiren': this.exclureGroupeSiren,
          'status_prestij': this.selectedStatusPrestij,
          'statusId': this.selectedSousStatus.length > 0 ? this.selectedSousStatus : this.selectedStatus,
          'segment_commercial': this.selectedSegmentsCommerciaux,
          'delegation': this.selectedDelegations,
          'campagne': this.selectedCampagnes,
          'oags': this.selectedOags,
          'oaps': this.selectedOaps,
          'equipes': this.equipes,
          'selectedTeam': this.selectedAffectedTeam,
          'demandeur': this.demandeur,
          'echantillon_annuel': this.echantillonAnnuel,
          'frequence': this.frequence,
          'descriptif': this.descriptif,
          'flag': this.selectedFlags,
          'typeUrgence': this.selectedTypesUrgences,
          'regleCumul': this.regleCumul,
          'nbDossierNir': this.nbDossierNir,
          'exclureBpij': this.exclureBpij,
          'dateTraitement': this.dateTraitement,
          'traitementStatusId': this.traitementStatusId,
        };
      },
      validateSiren: _.debounce(function (event) {
        this.errors.siren = checkSIREN(event.target.value) ? '' : 'saisir un siren valide';
        this.showFicheSiren = checkSIREN(event.target.value);
      }, 1000),
      getStatusTraiteId() {
        let data = {
          libelle_categorie: 'status_dossier',
          libelle_status: 'traite'
        };
        this.$axios
          .post("/administration/status/statutsByLibelle", data)
          .then(response => {
            const status = response.data.status;
            this.selectedStatus = [status.id];
          })
          .catch((error) => {
            console.log(error)
          });
      },
      getTypesControle(){
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/espaceQualite/types_controles")
          .then(response => {
            for (let item of response.data.data) {
              this.typesControle.push({value: item.id, text: item.libelle})
            }
            this.$store.commit('IS_LOADING', false);
          })
          .catch((error) => {
            this.handleErrors();
          });
      },
      getMotifsControle(){
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/espaceQualite/motifs_controles")
          .then(response => {
            for (let item of response.data.data) {
              this.motifsControle.push({value: item.id, text: item.libelle})
            }
            this.$store.commit('IS_LOADING', false);
          })
          .catch((error) => {
            this.handleErrors();
          });
      },
      getEquipes() {
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getEquipes")
          .then(response => {
            this.allEquipe = response.data.equipes;
            for (let equipe of response.data.equipes) {
              this.allEquipesOption.push({value: equipe.id, text: equipe.libelle});
            }
          })
          .catch(() => {
            self.handleErrors(self);
          });
      },
      getReglesCumul() {
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getReglesCumul")
          .then(response => {
            this.allRegleCumul = response.data.data;
            this.allRegleCumulOption.push({value: 'tous', text: 'Toutes les règles de cumul'});
            for (let regleCumul of response.data.data) {
              this.allRegleCumulOption.push({value: regleCumul.libelle_technique, text: regleCumul.libelle});
            }
          })
          .catch(() => {
            self.handleErrors(self);
          });
      },
      getTraitementsPrincipaux(){
        let self = this;
        this.$axios
          .get("/administration/traitementsPrincipaux")
           .then(response => {
            this.allTraitements = response.data.data;

          })
          .catch(() => {
            self.handleErrors(self);
          });
      },
      displayNbDossierNir() {
        if(this.nbDossierNir === 0 || this.nbDossierNir == 0){
          return "Tous";
        }else if(this.nbDossierNir == 5){
          return '1 seul';
        }else if(this.nbDossierNir == 10){
          return '2 à 5';
        }else if(this.nbDossierNir == 15){
          return '2 et +';
        }else{
          return (this.nbDossierNir -15)  + ' et +';
        }
      },
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
